module.exports = __webpack_public_path__ + "img/icon_utility.e5ca1740.png";